import { FileUpload, FormInput } from "@common/components/forms";
import { PetCustomReminderModel } from '@common/models/PetCustomReminders';
import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form';
import { ProgressBar } from "react-bootstrap";
import { ProgressState } from "@hospital/hooks";

export type IThirdPartyRemindersAttachmentsProps = {
    progress: ProgressState | undefined;
}

const LoadingProgressBar = ({ progress }: { progress: ProgressState }) =>
    <div>
        <ProgressBar>
            {progress.completed > 0 && <ProgressBar key={1} striped variant='success' now={100 * progress.completed / progress.total} />}
            {progress.errored > 0 && <ProgressBar key={2} striped variant='danger' now={100 * progress.errored / progress.total} />}
        </ProgressBar>
    </div>

export const ThirdPartyRemindersAttachments = observer(({ progress }: IThirdPartyRemindersAttachmentsProps) => {
    const { control, watch, register, formState: { errors, isDirty } } = useFormContext<PetCustomReminderModel>();
    const [isNotesDisable, setIsNotesDisable] = useState(true);
    const [showAlertmessage, setShowAlertmessage] = useState(false)

    useEffect(() => {
        const subscription = watch(({ attachmentStorageContent }, { name, type, }) => {
            if (type === "change" && name == "attachmentStorageContent") {
                if (attachmentStorageContent?.length! > 0) {
                    setIsNotesDisable(false);
                    setShowAlertmessage(false);
                } else {
                    setIsNotesDisable(true);
                    setShowAlertmessage(true);
                }
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    return (
        <>
            <FileUpload
                {...register('attachmentStorageContent' as any)}
                name="attachmentStorageContent"
                accept="*"
                multiple={true}
                isDirty={isDirty}
                highlightDirty={true}
                isInvalid={errors?.attachmentStorageContent ? true : false}
                uploadButtonText="Add Attachments"
                emptyText=""
                labelText="Attachment Files"
            />
            <FormInput
                label="Notes"
                fieldName="notes"
                type="textarea"
                control={control}
                highlightDirty={true}
                disabled={isNotesDisable}
            />
            {showAlertmessage &&
                <p className="text-danger pt-2">Attachments are required to save notes. Please reupload your files to ensure notes are saved.</p>
            }
            {progress &&
                <>
                    <div>
                        Uploading {progress.total} files...
                    </div>
                    <LoadingProgressBar progress={progress} />
                </>
            }
        </>
    )
});
